import { render, staticRenderFns } from "./ComposeMessage.vue?vue&type=template&id=d33cd8b6&scoped=true"
import script from "./ComposeMessage.vue?vue&type=script&lang=js"
export * from "./ComposeMessage.vue?vue&type=script&lang=js"
import style0 from "./ComposeMessage.vue?vue&type=style&index=0&id=d33cd8b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33cd8b6",
  null
  
)

export default component.exports